export const inputChange = (value, rowIndex, questionId) => ({
  type: 'CONSTANT_SUM_CHANGE',
  questionId,
  rowIndex,
  value,
});

export const constantSumNone = (checked, questionId) => ({
  type: 'CONSTANT_SUM_NONE',
  checked,
  questionId,
});
